var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuidelineOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 464,
    viewBox: "0 0 261 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -446,
    y: -66.9747,
    width: 388.253,
    height: 1323.41,
    rx: 30,
    transform: "rotate(-14.7767 -446 -66.9747)",
    fill: "#23404B",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidelineOverlay);
export default __webpack_public_path__ + "static/media/guidelineOverlay.a4e549081d7b1c13bdea138ab2c34c2e.svg";
export { ForwardRef as ReactComponent };